module.exports = __webpack_public_path__ + "static/img/wechat_jsapi_card.9c35158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat_jsapi_card.jpg
// module id = jEkg
// module chunks = 0